var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIl({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "israel",
    transform: "translate(-0.195 0.215)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_110",
    "data-name": "Ellipse 110",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(0.195 -0.215)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_236",
    "data-name": "Group 236",
    transform: "translate(2.143 3.331)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2076",
    "data-name": "Path 2076",
    d: "M171.516,148.235h-3.97l-1.985-3.539-1.985,3.539h-3.97l1.985,3.539-1.985,3.539h3.97l1.985,3.539,1.985-3.539h3.97l-1.985-3.539ZM168,151.774l-1.219,2.174h-2.438l-1.219-2.174,1.219-2.174h2.438Zm-2.438-4.348.454.809h-.907ZM161.9,149.6h.908l-.454.809Zm0,4.348.454-.809.454.809Zm3.658,2.174-.454-.809h.907Zm3.658-2.174h-.908l.454-.809Zm-.908-4.348h.908l-.454.809Z",
    transform: "translate(-152.069 -139.034)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2077",
    "data-name": "Path 2077",
    d: "M60.91,55.652H41.223A16.22,16.22,0,0,0,37.574,59.9H64.559A16.223,16.223,0,0,0,60.91,55.652Z",
    transform: "translate(-37.574 -55.652)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2078",
    "data-name": "Path 2078",
    d: "M41.223,393.812H60.91a16.22,16.22,0,0,0,3.649-4.247H37.574A16.223,16.223,0,0,0,41.223,393.812Z",
    transform: "translate(-37.574 -368.332)",
    fill: "#0052b4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIl);
export default __webpack_public_path__ + "static/media/IL.aaf846a4bc143fec4ea6289337c87b88.svg";
export { ForwardRef as ReactComponent };